import { DisabledTimeSlotAlertModal } from './DisabledTimeSlotAlertModal';

export default DisabledTimeSlotAlertModal;